import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from '../_services/local-storage.service';

@Component({
    selector: 'app-europe-access-modal',
    templateUrl: './europe-access-modal.component.html',
    styleUrls: ['./europe-access-modal.component.scss'],
    standalone: false
})
export class EuropeAccessModalComponent implements OnInit {

  hasEUPersonSearchAccess: string;
  euCheckbox: UntypedFormControl = new UntypedFormControl(false, Validators.required);
  showRequiredError: boolean = false;
  constructor(private localStorageService: LocalStorageService, private activeModal: NgbActiveModal) {
    this.hasEUPersonSearchAccess = this.localStorageService.getItem('hasEUPersonSearchAccess');
   }

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.close({action: "close"});
  }

  changeEUCheckbox(event) {
    if(event.target.checked) {
      this.euCheckbox.setValue(true);
    } else {
      this.euCheckbox.setValue(false);
    }
  }

  getEUAcknowledge() {
    this.showRequiredError = false;
    if(this.euCheckbox.valid && this.euCheckbox.value == true) {
      const euModal = {
        lastShown: new Date().getTime(),
        euAcknowledge: true
      }
      this.localStorageService.setItem('euConscent', JSON.stringify(euModal));
      this.activeModal.close({action: "success"})
    } else {
      if (this.euCheckbox instanceof UntypedFormControl) {
        this.euCheckbox.markAsTouched({ onlySelf: true });
      }
      this.showRequiredError = true;
  }
  }

  openPdf() {
    const url = `/eu-consent-document`;
    window.open(url, "_blank");
  }

}
